module.exports = __webpack_public_path__ + "fonts/OpenSans-Bold.f5331cb6.ttf";